export const API_BASE_URL = import.meta.env.VITE_API_ENDPOINT;
export const CMS_API_BASE_URL = import.meta.env.VITE_CMS_API_ENDPOINT;
